function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_556",
  "data-name": "Group 556",
  transform: "translate(1.414 1.414)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_323",
  "data-name": "Line 323",
  x1: 24.901,
  y2: 24.901,
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#a7a8a9",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_324",
  "data-name": "Line 324",
  x1: 24.901,
  y1: 24.901,
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#a7a8a9",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgCloseVar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.73,
    height: 27.73,
    viewBox: "0 0 27.73 27.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVar3);
export default __webpack_public_path__ + "static/media/close-var-3.49b8c399.svg";
export { ForwardRef as ReactComponent };